module.exports = __webpack_public_path__ + "static/media/supplier.83028406.png";